module.exports = __webpack_public_path__ + "img/richangshenghuoyongpin_shrz.11ec759e.png";